import {
  AsyncSingleSelectField,
  CharField,
  LinkField,
  NumberField,
  SingleSelectField,
  SwitchField,
} from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col, Row } from "react-bootstrap"
import { Esemplare } from "../../types"
import { useEdizioneCreate, useEdizioneLazy, useEdizioniLazy } from "../../hooks/edizioni"
import { useBibliotecaCreate, useBibliotecaLazy, useBibliotecheLazy } from "../../hooks/biblioteche"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import EdizioneModal from "../Edizioni/EdizioneModal"
import BibliotecaModal from "../Biblioteche/BibliotecaModal"
import { transformErrorForForm } from "../../utils/utils"

export default function EsemplareForm({ col, showEdizione = false }: { col?: number; showEdizione?: boolean }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Esemplare>()

  const fetchEdizione = useEdizioneLazy()
  const fetchEdizioni = useEdizioniLazy()

  const fetchBiblioteca = useBibliotecaLazy()
  const fetchBiblioteche = useBibliotecheLazy()

  const createEdizione = useEdizioneCreate()
  const createBiblioteca = useBibliotecaCreate()

  const [modalStateCreateEdizione, modalActionsCreateEdizione] = useModalTrigger()
  const [modalStateCreateBiblioteca, modalActionsCreateBiblioteca] = useModalTrigger()

  return (
    <Row className="align-items-center mb-4">
      <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
        {showEdizione && (
          <AsyncSingleSelectField
            label="Edizione"
            layout="horizontal"
            placeholder="Seleziona un'edizione"
            onChange={(value) => {
              setFieldValue("edizione", value)
            }}
            clearable
            value={values.edizione}
            loadOptions={(inputValue: string) => {
              return fetchEdizioni({ search: inputValue }).then((edizioni) => {
                return edizioni.results?.map((edizione) => ({
                  label: edizione.opera_data?.titolo+' - '+edizione.titolo_completo,
                  value: edizione.id,
                }))
              })
            }}
            loadInitialValue={(id: number) =>
              fetchEdizione(id).then((edizione) => {
                return { label: edizione.opera_data?.titolo+' - '+edizione.titolo_completo, value: edizione.id }
              })
            }
            isValid={submitCount > 0 ? !getIn(errors, "edizione") : undefined}
            errorMessage={getIn(errors, "edizione")}
            required
          >
            <SingleSelectField.Add
              onClick={() => {
                modalActionsCreateEdizione.open()
              }}
            />
          </AsyncSingleSelectField>
        )}
        <AsyncSingleSelectField
          label="Biblioteca"
          placeholder="Seleziona una biblioteca"
          layout="horizontal"
          onChange={(value) => {
            setFieldValue("biblioteca", value)
          }}
          clearable
          value={values.biblioteca}
          loadOptions={(inputValue: string) => {
            return fetchBiblioteche({ search: inputValue }).then((biblioteche) => {
              return biblioteche.results?.map((biblioteca) => ({
                label: biblioteca.nome,
                value: biblioteca.id,
              }))
            })
          }}
          loadInitialValue={(id: number) =>
            fetchBiblioteca(id).then((biblioteca) => {
              return { label: biblioteca.nome, value: biblioteca.id }
            })
          }
          isValid={submitCount > 0 ? !getIn(errors, "biblioteca") : undefined}
          errorMessage={getIn(errors, "biblioteca")}
          required
        >
          <SingleSelectField.Add
            onClick={() => {
              modalActionsCreateBiblioteca.open()
            }}
          />
        </AsyncSingleSelectField>

        <CharField
          label="Codice"
          layout="horizontal"
          value={values.codice}
          onChange={(value) => {
            setFieldValue("codice", value)
          }}
          isValid={submitCount > 0 ? !getIn(errors, "codice") : undefined}
          errorMessage={getIn(errors, "codice")}
          required
        />
        <LinkField
          label="Link"
          layout="horizontal"
          value={values.link}
          onChange={(value) => {
            setFieldValue("link", value)
          }}
          errorMessage={getIn(errors, "link")}
        />
        <LinkField
          label="Link 2"
          layout="horizontal"
          value={values.link_2}
          onChange={(value) => {
            setFieldValue("link_2", value)
          }}
          errorMessage={getIn(errors, "link_2")}
        />
        <LinkField
          label="Link 3"
          layout="horizontal"
          value={values.link_3}
          onChange={(value) => {
            setFieldValue("link_3", value)
          }}
          errorMessage={getIn(errors, "link_3")}
        />
        <NumberField
          label="Ordine"
          layout="horizontal"
          value={values.ordine}
          onChange={(value) => {
            setFieldValue("ordine", value)
          }}
          errorMessage={getIn(errors, "ordine")}
        />
        <SwitchField
          label="Consultato"
          layout="horizontal"
          value={values.consultato}
          onChange={(value) => {
            setFieldValue("consultato", value)
          }}
        />
        <SwitchField
          label="Digitalizzato"
          layout="horizontal"
          value={values.digitalizzato}
          onChange={(value) => {
            setFieldValue("digitalizzato", value)
          }}
        />
      </Col>
      {modalStateCreateEdizione.isOpen && (
        <EdizioneModal
          show={modalStateCreateEdizione.isOpen}
          onClose={modalActionsCreateEdizione.close}
          showOpera={showEdizione}
          save={(values) => {
            return createEdizione.mutateAsync(values).then((edizione) => {
              setFieldValue("edizione", edizione.id)
              modalActionsCreateEdizione.close()
            })
          }}
          title="Crea edizione"
        />
      )}
      {modalStateCreateBiblioteca.isOpen && (
        <BibliotecaModal
          show={modalStateCreateBiblioteca.isOpen}
          onClose={modalActionsCreateBiblioteca.close}
          save={(values, actions) => {
            return createBiblioteca.mutateAsync(values).then((biblioteca) => {
              setFieldValue("biblioteca", biblioteca.id)
              modalActionsCreateBiblioteca.close()
            }).catch((e) => {
              actions.setErrors(transformErrorForForm(e))
            })
          }}
          title="Crea biblioteca"
        />
      )}
    </Row>
  )
}
